<template>
  <div class="NeueRouteContainer">
    <Header :name="$store.state.editStrecke ? 'Route bearbeiten' : 'Neue Strecke anlegen'"/>
    <div class="cursor-pointer header" @click="goBackToProfil">
      <SVGIcon size="small" name="arrow_back_blue" class="selfAlignCenter"/>
      <div class="headerText colorBlue">zurück</div>
    </div>

    <p class="colorLightGrey">Autobahnanschluss für Start und Ziel auswählen</p>

    <div >
      <!-- Streckenname -->
      <div
        class="strecke borderTopWidth1 borderTopStyleSolid borderBlue padding20 cursor-pointer"
        @click="focus('streckennameEingabe')"
      >
        <div class="streckeHeader">
          <div class="displayflex width100">
            <!-- <SVGIcon name="start_off" v-if="strecke.start" class="selfAlignCenter"/>
            <SVGIcon name="start" v-else class="selfAlignCenter"/>-->
            <SVGIcon name="route_button_grau" v-if="strecke.titel" class="selfAlignCenter"/>
            <SVGIcon name="route_button" v-else class="selfAlignCenter"/>
            <div class="streckeText marginleft15 width84">
              <input
                ref="streckennameEingabe"
                :bind="strecke.titel"
                @input="strecke.titel = $event.target.value"
                :value="strecke.titel"
                type="text"
                name="routeName"
                id="routeName"
                placeholder="Mein Streckenname"
                :class="[strecke.titel ? 'colorDarkGrey' : 'colorBlue']"
              >
            </div>
          </div>
        </div>
      </div>

      <div class="strecke borderBlue padding20 cursor-pointer" @click="focus('startSearchBox')">
        <div class="streckeHeader">
          <!-- Auswahl StartAnschlussstelle -->
          <div class="displayflex width100">
            <SVGIcon name="start_off" v-if="strecke.start" class="selfAlignCenter"/>
            <SVGIcon name="start" v-else class="selfAlignCenter"/>
            <div class="streckeText marginleft15 width84">
              <SearchBox
                ref="startSearchBox"
                :value="strecke.start"
                @input="handleStreckeInput('start',...arguments)"
                @typing="resetInput('start')"
                :options="getAnschlussstellenListe()"
                :display="['roadnumber','first_name']"
                :divider="' '"
                :placeholder="'Start (Autobahnanschluss)'"
                :classes="['routeDetails']"
              />
              <!-- strecke.start ? 'colorDarkGrey' : 'colorBlue',  -->
            </div>
          </div>
        </div>
      </div>
      <div class="strecke borderBlue padding20 cursor-pointer" @click="focus('zielSearchBox')">
        <div class="streckeHeader">
          <!-- Auswahl ZielAnschlussstelle -->
          <div class="displayflex width100">
            <SVGIcon name="ziel_off" v-if="strecke.ziel" class="selfAlignCenter"/>
            <SVGIcon name="ziel" v-else class="selfAlignCenter"/>
            <div class="streckeText marginleft15 width84">
              <SearchBox
                ref="zielSearchBox"
                :value="strecke.ziel"
                @input="handleStreckeInput('ziel', ...arguments)"
                @typing="resetInput('ziel')"
                :options="getAnschlussstellenListe()"
                :display="['roadnumber','first_name']"
                :divider="' '"
                :placeholder="'Ziel (Autobahnanschluss)'"
                :classes="['routeDetails']"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="displayflex streckeButtons cursor-pointer" v-if="edit" @click="deleteRoute()">
        <SVGIcon name="trash_blue"/>
        <div class="marginleft15 selfAlignCenter colorBlue">Strecke löschen</div>
      </div>
      <div
        v-if="anschlussstellenAusgewaehlt && strecke.coordinates"
        class="displayflex streckeButtons cursor-pointer"
        @click="edit
                        ? setKartenMode({mode:'route_bearbeiten', strecke,  type:getType()})
                        : setKartenMode({mode:'route_anlegen',strecke})"
      >
        <SVGIcon name="kartenansicht_on"/>
        <div class="marginleft15 selfAlignCenter colorBlue">Auf der Karte anzeigen</div>
      </div>

      <p v-if="loading">Strecke wird geladen</p>

      <div
        v-if="strecke.coordinates"
        class="displayflex streckeButtons cursor-pointer fontweight600 colorBlue borderBlue borderRadius30 margin20_0 borderStyleSolid borderWidth1"
        @click="saveRoute"
      >
        <SVGIcon v-if="strecke.coordinates" name="route" class="selfAlignCenter"/>
        <div class="marginleft15 selfAlignCenter">Strecke speichern</div>
      </div>
    </div>
  </div>
</template>

<script>
import anschlussstellen from "./../../HelperClasses/LCL_Anschlussstellen";

import SearchBox from "./../CoreComponents/SearchBox.vue";
import Header from "./../CoreComponents/Header.vue";

export default {
  name: "NeueRoute",
  components: {
    SearchBox,
    Header
  },
  data: function() {
    return {
      saveInitialEditStrecke: null,
      anschlussstellenAusgewaehlt: null,
      edit: false,
      routeLoaded: false, // verhindert doppeltes Laden der selben Route
      loading: false,
      defaultRoute: {
        titel: "", // Der Titel der Route z.B. "Nach Hause"
        coordinates: null, // Initialen Koordinaten auf null setzen
        start: null, // => wird einem Objekt zugeordnet bei Auswahl durch die Textsuche oder automatisch nach Auswahl auf der Karte
        ziel: null,
        zeitVon: new Date(""), // Zeitraum in welchem der Nutzer die Push Nachrichten empfangen möchte
        zeitBis: new Date(""),
        wochentage: {
          // Wochentage an welchen der Nutzer die Push Nachrichten empfangen möchte
          Mo: true,
          Di: true,
          Mi: true,
          Do: true,
          Fr: true,
          Sa: false,
          So: false
        },
        notification: false, // ob Dem Nutzer Push Nachrichten für die Route geschickt werden sollen
        notificationExtended: false, // Ob das Benachrichtigungsmenü unter Meine Benachrichtigungen sichtbar ist
        notificationInterval: 5, // Interval(Minuten) in welchem der Nutzer Nachrichten erhält

        extended: false, // ob erweiterte Ansicht sichtbar sind sowie Buttons
        layerVisible: false, // Ob die Geometrie als Layer auf der Karte sichtbar ist
        showWebcams: false, // Ob die Webcams sichtbar sind
        showElektrotankstellen: false // ob die Elektrotankstellen sichtbar sind
      }
    };
  },
  mounted() {
    if (this.edit) {
      this.anschlussstellenAusgewaehlt = true;
    } else {
      this.checkAnschlussstellenAusgewaehlt();
      this.getZeitBis();
      this.getZeitVon();
    }
  },
  methods: {
    getZeitBis() {
      this.strecke.zeitBis = this.roundTimeQuarterHour(
        new Date().getTime() + 2 * 60 * 60 * 1000
      );
    },
    getZeitVon() {
      this.strecke.zeitVon = this.roundTimeQuarterHour();
    },
    roundTimeQuarterHour(time) {
      let timeToReturn = time ? new Date(time) : new Date();
      timeToReturn.setMilliseconds(
        Math.round(timeToReturn.getMilliseconds() / 1000) * 1000
      );
      timeToReturn.setSeconds(Math.round(timeToReturn.getSeconds() / 60) * 60);
      timeToReturn.setMinutes(Math.round(timeToReturn.getMinutes() / 15) * 15);
      return timeToReturn;
    },
    resetInput(target) {
      this.anschlussstellenAusgewaehlt = false;
      this.strecke.coordinates = null;
      this.strecke[target] = null;
    },
    focus(focusRef) {
      this.$refs[focusRef].focus();
    },
    getType() {
      if (
        this.strecke.start.first_name !==
          this.saveInitialEditStrecke.start.first_name ||
        this.strecke.ziel.first_name !==
          this.saveInitialEditStrecke.ziel.first_name
      ) {
        return "anschlussstellen";
      } else {
        return "geometry";
      }
    },
    getAnschlussstellenListe() {
      return anschlussstellen.getListe();
    },
    checkAnschlussstellenAusgewaehlt() {
      this.anschlussstellenAusgewaehlt = !!(
        this.strecke.start && this.strecke.ziel
      );
      if (this.anschlussstellenAusgewaehlt && !this.routeLoaded) {
        this.strecke.coordinates = null;
        this.routeLoaded = true;
        const obj = {
          start: this.strecke.start.locationcode,
          ziel: this.strecke.ziel.locationcode
        };
        this.loading = true;
        this.$store.dispatch("fetchToServer", {
          subURL: "getRoute",
          method: "POST",
          body: obj,
          onSuccess: data => {
            this.strecke.coordinates = JSON.parse(JSON.stringify(data));
            this.loading = false;
          },
          onFailure: error => {
            this.loading = false;
            this.$store.dispatch(
              "sendNotificationError",
              "Ein Fehler beim Laden des Services ist aufgetreten. Bitte versuchen Sie es später erneut."
            );
          }
        });
      }
    },

    saveRoute() {
      if (this.loading) {
        this.$store.dispatch(
          "sendNotificationError",
          "Bitte warten Sie bis die Route vollständig geladen wurde."
        );
        return;
      } else if (!this.anschlussstellenAusgewaehlt) {
        this.$store.dispatch(
          "sendNotificationError",
          "Bitte wählen Sie Start und Ziel aus."
        );
        return;
      } else if (!this.strecke.coordinates) {
        this.$store.dispatch(
          "sendNotificationError",
          "Ein Fehler beim Laden der Route ist aufgetreten. Bitte versuchen Sie es später erneut."
        );
        return;
      }

      if (this.edit) {
        this.checkRouteTitel();
        this.$store.dispatch("saveEditRoute", this.strecke);
      } else {
        // setzen der ID
        if (this.routen.length !== 0) {
          this.strecke.id = this.routen[this.routen.length - 1].id + 1;
        } else this.strecke.id = 1;
        this.checkRouteTitel();
        this.$store.dispatch("saveNeueRoute", this.strecke);
      }
      this.$store.commit("setActiveProfilOption", null);
    },

    handleStreckeInput(target, value) {
      this.strecke[target] = value;
      this.routeLoaded = false;
      this.checkAnschlussstellenAusgewaehlt();
    },
    // #########################
    // Route anlegen
    // #########################
    // Route auf Karte
    setKartenMode(mode) {
      this.$store.commit("setKartenMode", mode);
      this.$emit("closeSidebar");
    },

    checkRouteTitel() {
      // setzen des Routennamens wenn dieser leer ist
      if (this.strecke.titel.trim() === "") {
        this.strecke.titel = `Route ${this.strecke.id}`;
      }
    },
    deleteRoute() {
      if (confirm("Möchten Sie diese Route wirklich löschen?")) {
        this.$store.dispatch("deleteRoute", this.strecke);
        this.goBackToProfil();
      }
    },
    goBackToProfil() {
      this.$store.dispatch("setEditRoute", null);
      this.$emit("GoBackToProfil");
    }
  },
  computed: {
    routen() {
      return this.$store.state.routen;
    },
    strecke() {
      if (this.$store.state.editStrecke) {
        if (!this.saveInitialEditStrecke) {
          this.saveInitialEditStrecke = JSON.parse(
            JSON.stringify(this.$store.state.editStrecke)
          );
        }
        this.edit = true;
        return this.$store.state.editStrecke;
      } else {
        return this.defaultRoute;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.NeueRouteContainer {
  height: 100%;
  width: 100%;
  font-size: 16px;
}
.header {
  display: flex;
  margin-bottom: 15px;
}
.headerText {
  display: flex;
  flex-direction: column;
  align-self: center;
  margin-left: 30px;
}

.strecke {
  border-bottom-width: 1px;
  border-bottom-style: solid;
}
.streckeHeader,
.streckeOptions {
  display: flex;
  justify-content: space-between;
}
.streckeText {
  display: flex;
  flex-direction: column;
  align-self: center;
  text-align: center;
}

.routeDetails {
  height: 35px;
}

.streckeOptions {
  margin: 20px;
}

.routeSpeichern {
  margin-top: 20px;
  margin-left: 20px;
  width: fit-content;
  border-radius: 30px;
  padding: 10px;
  color: white;
  display: flex;
}

.streckeButtons {
  padding: 10px 20px;
}

input[type="radio"] {
  margin: 0;
  width: 36px;
  height: 36px;
  background: white;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  border-radius: 50%;

  border: 2px solid #9ba0a4;
  transition: 0.2s all linear;
  outline: none;
}
input[type="radio"]:checked {
  border: 12px solid #64b5f6;
}
label {
  font-weight: 500 !important;
}
</style>
